var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.category)?_c('div',{class:_vm.$style.container},[(_vm.category.icon)?_c('div',{class:_vm.$style.icon,style:(`background-image: url(${_vm.category.icon})`)}):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.name))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }